<script>
/**
 * Descripción: Pantalla para Gestionar Clientes
 *
 * @displayName CustomerEditorViewComponent
 */

import { mapActions } from 'vuex';
import httpService from '@/services/httpService.js';
import BaseArrayHelper from '@/helpers/BaseArrayHelper.js';

const CustomerContactFilterViewComponent = () =>
  import('@/views/Customer/CustomerContactFilterViewComponent.vue');

const PartnerByCustomerFilterViewComponent = () =>
  import('@/views/PartnerByCustomer/PartnerByCustomerFilterViewComponent.vue');

export default {
  name: 'CustomerEditorViewComponent',

  components: {
    CustomerContactFilterViewComponent,
    PartnerByCustomerFilterViewComponent
  },

  data() {
    return {
      customer: this.$_setCustomerObject(),
      loading: false,
      textFieldProps: {
        'append-icon': 'mdi-calendar'
      },
      extraParams: {
        customerId: this.$router.currentRoute.params.Id,
        partnerId: ''
      },
      partnerId: undefined
    };
  },

  created() {
    /**
     * Configuracion Encabezado
     */
    this.addNavbar(['Gestionar Cliente']);

    /**
     * Determinar si Es nuevo / editor
     */
    this.$_getObject();
  },

  methods: {
    /**
     * Determinar si Es nuevo / editor
     */
    $_getObject() {
      let data = this.$router.currentRoute.params.Id;
      if (data) {
        //HttpServices a la vista para obtener Vista
        this.customer.customerId = data;
        this.loading = true;
        httpService.post('/Customer/GetView', this.customer).then(response => {
          this.loading = false;
          if (response != undefined) {
            // Encontro la entidad
            this.customer = BaseArrayHelper.SetObject({}, response.data);

            this.customer.activationDate = new Date(
              this.customer.activationDate.replace(/T/g, ' ')
            );
          } else {
            this.$_returnToFilter();
          }
        });
      }
    },

    /**
     * Configuración NavBar
     */
    ...mapActions('navbar', ['addNavbar']),

    /**
     * Obj de la pantalla
     */
    $_setCustomerObject() {
      return {
        customerId: undefined,
        locationId: undefined,
        customerName: undefined,
        customerAddress: undefined,
        activationDate: undefined,
        inactivationDate: undefined,
        activo: true,
        customerDetails: undefined
      };
    },

    /**
     * Volver al Filtro
     */
    $_returnToFilter() {
      this.$router.push({ name: 'CustomerFilterViewComponent' });
    },

    $_sendToApi() {
      this.loading = true;
      let object = BaseArrayHelper.SetObject({}, this.customer);
      if (this.partnerId) {
        object.partnerId = this.partnerId;
      }
      httpService.post('Customer/SaveObject', object).then(response => {
        if (response != undefined) {
          //Logica JS luego de la acción exitosa!!!
          this.$router.push({ name: 'CustomerFilterViewComponent' });
        }
        this.loading = false;
      });
    },

    $_sendToApiPartner() {
      httpService
        .post('PartnerByCustomer/SaveObject', {
          customerId: parseInt(this.$router.currentRoute.params.Id),
          partnerId: this.partnerId
        })
        .then(response => {
          if (response != undefined) {
            //Logica JS luego de la acción exitosa!!!
            this.$refs.PartnerByCustomer.$_refresh();
            this.$_openModal();
            this.partnerId = undefined;
          }
        });
    },

    /**
     * Open PopUp
     */
    $_openModal() {
      this.$refs.modalPopUp.$_openModal();
    }
  }
};
</script>

<template>
  <div>
    <!-- @ Use Loanding... -->
    <BaseSkeletonLoader v-if="loading" type="card-avatar, article, actions" />
    <div v-else>
      <!-- @BaseDialog -->
      <BaseDialog ref="modalPopUp" tittle="Partners">
        <div slot="Content">
          <BaseForm :method="$_sendToApiPartner" :cancel="$_openModal">
            <div slot="body">
              <!-- @BaseSelect -->
              <BaseSelect
                v-model="partnerId"
                label="Partner"
                endpoint="/Partner/GridWithList"
                itemText="partnerName"
                itemValue="partnerId"
              />
            </div>
          </BaseForm>
        </div>
      </BaseDialog>
      <h3>Gestionar Cliente</h3>
      <v-divider></v-divider>
      <v-flex xs12 sm12 md12>
        <!-- @BaseForm -->
        <!-- @BaseForm -->
        <BaseForm :method="$_sendToApi" :cancel="$_returnToFilter">
          <div slot="body">
            <v-row>
              <v-col cols="12" md="4">
                <!-- @BaseInputList -->
                <BaseInput
                  label="Nombre"
                  v-model="customer.customerName"
                  :validate="['text']"
                  :max="100"
                />
              </v-col>
              <v-col cols="12" md="4">
                <!-- @BaseInputList -->
                <BaseInput
                  label="Dirección"
                  v-model="customer.customerAddress"
                  :validate="['text']"
                  :max="100"
                />
              </v-col>
              <v-col cols="12" md="4">
                <!-- @BaseSelect -->
                <BaseSelect
                  v-model="customer.locationId"
                  label="Locación"
                  endpoint="/Location/GridWithList"
                  itemText="locationName"
                  itemValue="locationId"
                  :validate="['text']"
                />
              </v-col>
              <v-col cols="12" md="4">
                <!-- @BaseDatePicker -->
                <BaseDatePicker
                  label="Fecha de Activación"
                  type="date"
                  v-model="customer.activationDate"
                  :textFieldProps="textFieldProps"
                  :validate="['text']"
                />
              </v-col>
              <v-col cols="12" md="4" v-if="customer.inactivationDate">
                <!-- @BaseInputList -->
                <BaseInput
                  label="Fecha de Inactivación"
                  v-model="customer.inactivationDate"
                  :max="100"
                  :readonly="true"
                />
              </v-col>
              <v-col cols="12" md="4">
                <!-- @BaseInputList -->
                <BaseTextArea
                  label="Detalles"
                  v-model="customer.customerDetails"
                  :max="100"
                  rows="1"
                />
              </v-col>
              <v-col cols="12" :md="customer.customerId == undefined ? 2 : 4">
                <div
                  class="pa-2"
                  style=" display: flex;
                        align-items: center;
                        justify-content: center;"
                >
                  <BaseSwitch v-model="customer.activo" label="Estado" />
                </div>
              </v-col>
              <v-col cols="12" md="2" v-if="!customer.customerId">
                <!-- @BaseSelect -->
                <BaseSelect
                  v-model="partnerId"
                  label="Partner"
                  endpoint="/Partner/GridWithList"
                  itemText="partnerName"
                  itemValue="partnerId"
                />
              </v-col>
            </v-row>
          </div>
          <!-- @slot Use this slot afterForm -->
          <div slot="afterForm" v-if="this.$router.currentRoute.params.Id">
            <h3>Contactos</h3>
            <v-divider></v-divider>
            <br />
            <CustomerContactFilterViewComponent :extraParams="extraParams" />

            <h3>Partner</h3>
            <v-divider></v-divider>
            <br />
            <PartnerByCustomerFilterViewComponent
              ref="PartnerByCustomer"
              :extraParams="extraParams"
              :fnNew="$_openModal"
            />
          </div>
        </BaseForm>
      </v-flex>
    </div>
  </div>
</template>
